import React from "react";
import { TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Classroom } from "@/types/classroom";

interface ClassTabsProps {
  classrooms: { name: string; id: string }[];
  selectedClassId: string;
  onClassChange: (value: string) => void;
}

export const ClassTabs = ({
  classrooms,
  selectedClassId,
  onClassChange,
}: ClassTabsProps) => {
  return (
    <TabsList className="w-full justify-start border-b rounded-none p-0 h-auto bg-transparent">
      {classrooms.map((classroom) => (
        <TabsTrigger
          key={classroom.id}
          value={classroom.id}
          className="px-6 py-3 rounded-none data-[state=active]:bg-white data-[state=active]:shadow-none data-[state=active]:border-b-2 data-[state=active]:border-teachstack-purple"
        >
          {classroom.name}
        </TabsTrigger>
      ))}
    </TabsList>
  );
};
